const { wrapPageElement, wrapRootElement } = require('./gatsby-common.js');

exports.wrapPageElement = wrapPageElement;
exports.wrapRootElement = wrapRootElement;
